import(/* webpackMode: "eager", webpackExports: ["ProtectedNavbar"] */ "/home/bdeh8989/dev.ecole-st-augustin.fr/v2/app/app/(protected)/_components/navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/home/bdeh8989/dev.ecole-st-augustin.fr/v2/app/components/navbar/navbar.tsx");
